// extracted by mini-css-extract-plugin
export default {"markdown":"markdown--pEem_"};